import { DrawRateConfig } from '@/config/game';

export default function getInitialDrawRate(drawRate?: DrawRateConfig[]) {
  return (
    (drawRate && drawRate.find((item) => Boolean(item.initial))) || { value: 1 }
  ).value;
}
